import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import WorkspaceDeepLinkGuard from "../components/WorkspaceDeepLinkGuard";
import { useDispatch, useSelector } from "react-redux";
import { isLogin } from '../service/user'
import { Spin } from "antd";
import styles from "./index.modules.less";
import { isMobileDevice } from "../utils/util";
import { canVisitModule } from "../utils/permission";

const WHITE_LIST_PATHS = [
  "/view/identity_select",
  "/view/no_access",
];

const IndexLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user, permission } = useSelector((state) => state);

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/view/home");
      return;
    }

    isLogin().then((res) => {
      if (!res) {
        navigate('/login', { replace: true });
        return;
      }

      dispatch.user.setUserAsync()
        .then((userInfo) => dispatch.permission.bootstrapAsync(userInfo))
        .catch((e) => {
          if (e?.errno === 10002 || e?.errno === 1042) {
            navigate('/login', { replace: true });
          }
        });
    })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (user) {
      dispatch.config.setConfigAsync();
    }
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!permission.initialized || permission.initializing) {
      return;
    }

    if (WHITE_LIST_PATHS.includes(location.pathname)) {
      return;
    }

    if (permission.needSelectIdentity && location.pathname !== "/view/identity_select") {
      navigate("/view/identity_select", { replace: true });
      return;
    }

    if (!permission.isUnionUser && location.pathname !== "/view/no_access") {
      navigate("/view/no_access?scene=union_not_open", { replace: true });
      return;
    }

    const isMobile = isMobileDevice() || window.innerWidth <= 768;
    const canOpenComplaint = canVisitModule({
      identityType: permission.identityType,
      permissionCodes: permission.permissionCodes,
      requiredPermission: "complaint_handling",
    });
    if (
      isMobile &&
      !permission.needSelectIdentity &&
      permission.isUnionUser &&
      canOpenComplaint &&
      ["/view", "/view/home"].includes(location.pathname)
    ) {
      navigate("/view/complaint_center", { replace: true });
      return;
    }

    if (!permission.needSelectIdentity && permission.landingPath && ["/view", "/view/home"].includes(location.pathname) && permission.landingPath !== location.pathname) {
      navigate(permission.landingPath, { replace: true });
    }
  }, [location.pathname, navigate, permission]);

  if (permission.initializing || !permission.initialized) {
    return (
      <div className={styles.loadingWrapper}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="container">
      <WorkspaceDeepLinkGuard />
      <Header />
      <Outlet />
    </div>
  );
};

export default IndexLayout;
